// extracted by mini-css-extract-plugin
export default {"Timer":"Timer_Timer__wKfF1"};